import 'isomorphic-fetch'

import { venuePartnerBenefitsEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'

export const fetchVenuePartnerBenefitsByVenueId = async venueId => {
  if (!venueId) {
    return []
  }

  const { method, url } = venuePartnerBenefitsEndpoint.get(venueId)
  const idToken = getIdToken()
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${idToken}` },
    method
  }).then(async res => await getApiResponseInJSON(res))

  return (response?.dataFields || []).map(field => ({
    ...field,
    _id: field?._id != null ? String(field._id) : field?._id
  }))
}
